module.exports = __webpack_public_path__ + "static/media/knolskape_logo.9c47f7c9.png";